<template>
  <main class="detail-teacher">
    <div class="row">
      <div class="col-md-12 top-wrapper">
        <TopTemplate>
          <template v-slot:left-element>
            <a
              @click="$router.go(-1)"
              class="btn btn-outline-primary button"
              :disabled="loading"
            >
              <i class="arrow left"></i>
              Retour
            </a>
          </template>

          <template v-if="statusSchoolYear" v-slot:right-element>
            <div class="d-flex buttons-wrapper buttons-teachers">
              <router-link
                :to="{ name: 'EditTeacher', params: { id: referenceId } }"
                class="btn button btn-primary"
                :disabled="loading"
              >
                <i class="icon-edit-03"></i>
                Modifier
              </router-link>
              <a
                @click.prevent="deleteTeacher(referenceId)"
                class="btn btn-outline-primary button"
                :disabled="loading"
              >
                <i class="icon-trash"></i>
                Supprimer
              </a>
            </div>
          </template>
        </TopTemplate>
      </div>
    </div>
    <div v-if="loading" class="card mt-4 text-center d-block pt-4 pb-4">
      <div class="spinner-border text-info" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

    <div v-if="!loading">
      <div class="general-info">
        <div class="details">
          <div class="row container-fluid">
            <div class="col-md-12">
              <h3>Informations générales</h3>
            </div>

            <div class="col-md-6 bloc-info">
              <span class="name_propre">
                <b>Nom & Prénom : </b>{{ reference.first_name }}
                {{ reference.last_name }}</span
              >
            </div>
            <div class="col-md-6 bloc-info">
              <!--   <i class="icon-phone"></i> -->
              <span v-if="reference.phone">
                <b>Numéro de téléphone : </b>
                {{ formatPhone(reference.phone) }}</span
              >
              <span v-else> <b>Numéro de téléphone : </b>Non renseigné</span>
            </div>
            <div class="col-md-6 bloc-info">
              <span v-if="reference.address !== 'null' && reference.address">
                <b>Adresse : </b>{{ reference.address }}</span
              >
              <span v-if="!reference.address || reference.address === 'null'"> <b>Adresse : </b>Non renseigné</span>
            </div>
            <div class="col-md-6 bloc-info">
              <span v-if="reference.email !== 'null' && reference.email">
                <b>Adresse email : </b>{{ reference.email }}</span
              >
              <span v-if="!reference.email || reference.email === 'null'"> <b>Adresse email : </b>Non renseigné</span>
             
            </div>
          </div>
        </div>
      </div>
      <div class="general-info details-list-class">
        <div class="details">
          <div class="row container-fluid">
            <h3>Classes & Matières</h3>
            <div v-if="listClasses.length === 0">
              <span>Non renseigné</span>
            </div>
            <div v-else class="row">
              <div
                class="col-md-3"
                v-for="classe in reference.class_courses"
                :key="classe.id"
              >
                <div class="row class">
                  <div class="col-md-1">
                    <div
                      class="buttons-wrapper buttons-teachers"
                      @click="classe.Active = !classe.Active"
                    >
                      <i v-if="classe.Active" class="arrow up" />
                      <i v-if="!classe.Active" class="arrow down flech" />
                    </div>
                  </div>

                  <div class="col-md-1">
                    <p class="centre">{{ classe.name }}</p>
                  </div>
                </div>

                <div class="course" v-if="!classe.Active">
                  <div v-for="course in classe.courses" :key="course.id">
                    <span class="nameCourse"> {{ course.name }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="general-info details">
        <div class="accordSid" @click="toggleEmploi()">
         
          <h3>Emploi du temps</h3>
          <div class="icons-wrapper">
            <i v-if="showEmploi" class="icon-Minus color-green" />
            <i v-else class="icon-Add color-green" />
          </div>
        </div>

        <div v-if="showEmploi">
          <div class="row container-fluid">
            <div v-if="referenceEmploi === null">
              <span>Non renseigné</span>
            </div>
            <iframe
              v-else
              :src="referenceEmploi"
              scrolling="no"
              frameborder="0"
              width="100%"
              height="1120"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>




<script>
import TopTemplate from "../../components/toptemplate/TopTemplate.vue";
import TeacherService from "../../services/teacher.service";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import {mapGetters} from "vuex";
export default {
  name: "DetailTeacher",
  components: {
    TopTemplate,
  },
  data() {
    return {
      referenceId: null,
      loading: false,
      listClasses: [],
      listCourses: [],
      reference: {},
      showEmploi: false,
      passageYears: null,
    };
  },
  computed: {
    ...mapGetters(["getPassageYears"]),
    statusSchoolYear(){
      return this.getPassageYears.status;
    },
    referenceEmploi() {
      return this.reference.timetable ? window.location.origin + this.reference.timetable + "#view=FitH" : null;
    },
  },
  watch: {
    getPassageYears(val) {
      if (val.id) {
        this.passageYears = val.id;
        this.getDetails();
      }
    },
  },
  created() {
    this.referenceId = this.$route.params.id;
    if (this.getPassageYears.id) {
      this.passageYears = this.getPassageYears.id;
      this.getDetails();
    }
  },

  methods: {
    toggleEmploi() {
      this.showEmploi = !this.showEmploi;
    },
    formatPhone(value) {
      const phoneNumber = parsePhoneNumberFromString(value, "TN");
      console.log(phoneNumber);
      return phoneNumber ? phoneNumber.formatNational() : "__";
    },
    getDetails() {
      this.loading = true;
      const config= {
        params: {
          school_year: this.getPassageYears.id
        }
      }
      TeacherService.get(this.referenceId, config)
        .then((response) => {
          this.reference = response.data.data;
          this.reference.classes = this.reference.classes.map((obj) => ({
            ...obj,
            Active: true,
          }));
          if (this.reference.class_courses.length) {
            this.listClasses = this.reference.class_courses;
          }
        })
        .catch((error) => {
           if (error.response && error.response.status === 404) {
              this.$router.push('/error-404');
            }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    deleteTeacher(id) {
      const Swal = require("sweetalert2");
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-confirm  btn-primary",
          cancelButton: "btn  btn-cancel  btn-outline-primary",
        },
        buttonsStyling: false,
        showCloseButton: true,
      });
      swalWithBootstrapButtons
        .fire({
          title: this.$t("common.confirmDeleteTeacher"),
          icon: "warning",
          showCloseButton: true,
          showCancelButton: true,
          confirmButtonText: this.$t("common.deletIT"),
          cancelButtonText: this.$t("common.noCancel"),
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            swalWithBootstrapButtons.fire(
              this.$t("common.teacherDeleted"),
              "",
              "success"
            );
            TeacherService.delete(id).then(
              () => {
                this.$router.push({ name: "teacher_list" });
              },
              (error) => {
                this.loading = false;
              }
            );

            // TeacherService.delete(id);
            // this.$router.push({ name: "teacher_list" });
          }
        });
    },
  },
};
</script>

